import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import Amplify, { Auth, Hub } from 'aws-amplify'; 
import awsconfig from './aws-exports'; 
Amplify.configure(awsconfig); 

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-material-design-icons/styles.css'
import './assets/css/main.css';

import '@aws-amplify/ui-vue';

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = false

//App wide listener
Hub.listen('auth', async (data) => {
  if(data.payload.event === 'signIn') {
    var user = await Auth.currentAuthenticatedUser(); 
    store.dispatch("setUser", user);
    router.replace("/admin/products")
  }
  if(data.payload.event === 'signOut') {
    store.dispatch("setUser", null);
    router.replace("/admin")
  }
}); 

Auth.currentAuthenticatedUser().then(res => {
  //Authenticated user
  store.dispatch("setUser", res); 
}).catch(() => {
  //Non authenticated user
  store.dispatch("setUser", null); 
}).finally(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})


